import { z } from 'zod'
import { EndDate, Id, StartDate } from './common-schemas'
import { GarItem } from './gar-item'

export namespace NormDocType {
  export interface Data {
    /** @description Identifier of the type of normative document */
    readonly id: number

    /** @description Name */
    readonly name: string

    /** @description Record validity start date */
    readonly startDate: Date

    /** @description Record validity end date */
    readonly endDate: Date
  }
}

/** @description Information on the type of normative document */
export class NormDocType extends GarItem<'NormDocType', NormDocType.Data> {
  static readonly SCHEMA: GarItem.Schema<NormDocType.Data> = z
    .strictObject({
      ID: Id,

      NAME: z.string().describe('Name'),

      STARTDATE: StartDate,

      ENDDATE: EndDate,
    })
    .transform<NormDocType.Data>(attributes => ({
      id: attributes.ID,
      name: attributes.NAME,
      startDate: attributes.STARTDATE,
      endDate: attributes.ENDDATE,
    }))

  readonly type = 'NormDocType'

  protected get schema() {
    return NormDocType.SCHEMA
  }
}
